import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenService } from './token.service';
import { InterceptorSkipHeader } from '../_constants/authConstants';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(
        public tokenService: TokenService,
        public router: Router
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> | any {
        // Skip interception for certain headers or endpoints
        if (request.headers.has(InterceptorSkipHeader)) {
            const headers = request.headers.delete(InterceptorSkipHeader);
            return next.handle(request.clone({ headers }));
        }

        // Skip certain requests from token injection
        const excludedUrls = [
            'SendVerificationCode',
            'setaduserincache',
            'getcheckssoenabled',
            'login',
            'login-with-sso',
            'login-with-geo-one-sso',
            'logout',
        ];

        if (excludedUrls.some((url) => request.url.includes(url))) {
            return next.handle(request.clone());
        }

        // Add moduleId from sessionStorage as a header
        const moduleId = sessionStorage.getItem('moduleId');
        const moduleMenuId = sessionStorage.getItem('moduleMenuId');

        let modifiedRequest = this.tokenService.injectToken(request);
        
        if (moduleId) {
            modifiedRequest = modifiedRequest.clone({
                setHeaders: {
                    'X-Module-Id': moduleId
                }
            });
        }

        if (moduleMenuId) {
            modifiedRequest = modifiedRequest.clone({
                setHeaders: {
                    'X-Module-Menu-Id': moduleMenuId
                }
            });
        }


        return next.handle(modifiedRequest).pipe(
            catchError(error => {
                if (error.status === 401 && !request.url.includes('refresh')) {
                    return this.tokenService.handle401Error(request, next);
                }
                return throwError(() => error);
            })
        );
    }
}